import { Link } from 'react-router-dom';
import { SITE_DOMAIN, SITE_NAME, SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/site';
import { openSalesIQChat } from '../utils/openSalesIQChat';

const socialLinks = [
  { href: 'https://facebook.com', label: 'Facebook', path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
  { href: 'https://twitter.com', label: 'Twitter', path: 'M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z' },
  { href: 'https://youtube.com', label: 'YouTube', path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' },
];

export default function Footer() {
  return (
    <footer className="t7-footer">
      <div className="container py-10 md:py-14">
        <div className="t7-footer__grid">
          <div>
            <p className="font-serif text-xl sm:text-2xl mb-3">Family Tree Maker</p>
            <p className="text-white/70 text-sm leading-relaxed mb-5 max-w-xs">
              Independent chat support for installation, migration, sync, and TreeVault questions at{' '}
              {SITE_DOMAIN}.
            </p>
            <div className="t7-actions">
              <a className="t7-btn t7-btn--solid" href={`tel:${SUPPORT_PHONE_TEL}`}>
                Call {SUPPORT_PHONE}
              </a>
              <button type="button" className="t7-btn t7-btn--outline" onClick={openSalesIQChat}>
                Live Chat
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.14em] text-[#bbf7d0] mb-4">Explore</h3>
            <ul className="space-y-2 list-none p-0 m-0">
              <li><Link to="/#about" className="text-white/75 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/#how-it-works" className="text-white/75 hover:text-white transition-colors">How it works</Link></li>
              <li><Link to="/#faq" className="text-white/75 hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.14em] text-[#bbf7d0] mb-4">Support</h3>
            <ul className="space-y-2 list-none p-0 m-0">
              <li><Link to="/#support-issues" className="text-white/75 hover:text-white transition-colors">Common issues</Link></li>
              <li><Link to="/#getting-started" className="text-white/75 hover:text-white transition-colors">Getting started</Link></li>
              <li>
                <a href={`tel:${SUPPORT_PHONE_TEL}`} className="text-white/75 hover:text-white transition-colors">
                  {SUPPORT_PHONE}
                </a>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openSalesIQChat}
                  className="text-white/75 hover:text-white transition-colors bg-transparent border-0 p-0 font-inherit cursor-pointer"
                >
                  Chat now
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.14em] text-[#bbf7d0] mb-4">Connect</h3>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/75 hover:text-[#bbf7d0] transition-colors p-1"
                  aria-label={social.label}
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d={social.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="t7-footer__bottom">
          <p className="m-0 break-words">
            © 2026 {SITE_NAME}. All rights reserved. | {SITE_DOMAIN}
          </p>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors">Refunds</Link>
          </div>
        </div>
        <p className="mt-6 text-xs text-white/45 leading-relaxed max-w-3xl m-0">
          We are an independent third-party support resource and are not affiliated with, endorsed by,
          or sponsored by Family Tree Maker or its trademark owners. Product names are used for
          identification only.
        </p>
      </div>
    </footer>
  );
}
